// Match Height Js
// Ensure the DOM is fully loaded
window.addEventListener("load", function() {
  matchHeight('.pdp-slide-item .pdp-badge-pill ');
  matchHeight('.product_card_shape');
});

function matchHeight(selector) {
  // Select all elements with the specified selector
  var elements = document.querySelectorAll(selector);
  if (elements.length === 0) {
    console.log("No elements found with the selector:", selector);
    return; // Exit if no elements are found
  }

  var maxHeight = 0;

  // First, find the tallest element
  elements.forEach(function(element) {
    var currentHeight = element.offsetHeight;
    if (currentHeight > maxHeight) {
      maxHeight = currentHeight;
    }
  });

  // Then, set all elements to the maxHeight
  elements.forEach(function(element) {
    element.style.height = maxHeight + 'px';
  });
}
// -------------------------------------------